import AppDispatcher from '../dispatcher/AppDispatcher';
import BaseConstants from '../constants/BaseConstants';

class LoginActions {

    login(user){
        AppDispatcher.handleServerAction({
            type: BaseConstants.LOGIN,
            user
        });
    }
}
export default new LoginActions();